import React from 'react'

const UnlimitedBar = (props) => {
    return <div className='unlimited-bar' />
}

export default UnlimitedBar



// WEBPACK FOOTER //
// ./resources/js/elements/UnlimitedBar.js